import { useState } from 'react'
import { Modal } from 'components'
import axios from 'axios'
import { checkDue } from 'helpers/date-helper'
import nprogress from 'nprogress'
import toast from 'react-hot-toast'
import { lang } from 'config'
import { XIcon } from 'components/icons'

const Content = ({ data, success }) => {
    const handleSubmit = (e) => {
        e.preventDefault()
        nprogress.start()

        axios.delete(`${process.env.REACT_APP_BACKEND_URL}/tax-payment/drop`, {
            data: {
                transaction_number: data.transaction_number
            }
        }).then((response) => {
            nprogress.done()
            toast.success(response.data.message)
            success()
        }).catch((error) => {
            nprogress.done()
            console.log(error.response)
            toast.error(error.response.data.message)
        })
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            {lang.are_you_sure_you_want_to_cancel} <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">{data.transaction_number}</span> ?
            <div className="text-xs">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.cancel}</span>
                </button>
            </div>
        </form>
    )
}

const Cancel = ({ data, onSuccess }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        onSuccess()
    }

    return (
        <>
            <button disabled={data.status === 'drop'} onClick={openModal} class={`${data.status === 'drop' ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white transition rounded-full active:hover:scale-90`}>
                <XIcon className="w-6 h-6" />
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.cancel} ${lang.tax_payment}`} content={<Content data={data} success={handleSuccess} />} />
        </>
    )
}

export default Cancel